/**
 * @Description 关注品牌，copy自src/views/youth/pages/map/custom_KA/xtc/components/LeftContent/common/ConcernedBrand.tsx
 */

import { FC, memo } from 'react';
import { Divider, Typography } from 'antd';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from './index.module.less';
import TableOfBlue from '@/common/components/business/TableOfBlue/TableOfBlue';
import IconFont from '@/common/components/IconFont';

interface LeftConOfTopBrandProps {
  brandList: any[];
  isSAAS?: boolean;
};
const LeftConOfTopBrand: FC<LeftConOfTopBrandProps> = ({
  brandList,
  isSAAS = false
}) => {
  const columns = [
    {
      key: 'name',
      title: <div className={cs(['c-666 fs-12', styles.rankItemTitle])}>排名</div>,
      importWidth: true,
      width: 46,
      noControlled: true,
      render(_, __, index) {
        if (!index) {
          return (
            <div className={styles.rankItem}>
              <img className={styles.rankImg} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_rank_1.png`} />
            </div>
          );
        } else if (index === 1) {
          return (
            <div className={styles.rankItem}>
              <img className={styles.rankImg} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_rank_2.png`} />
            </div>
          );
        } else if (index === 2) {
          return (
            <div className={styles.rankItem}>
              <img className={styles.rankImg} src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_rank_3.png`} />
            </div>
          );
        }
        return (
          <div className={styles.rankItem}>
            {index + 1}
          </div>
        );
      }
    },
    {
      key: 'brandName',
      title: <div className='c-666 fs-12'>名称</div>,
      // dragChecked: true,
      importWidth: true,
      width: 120,
      noControlled: true,
      render(_, record, __, ___, columnRenderDynamicConf) {
        return (
          <div className={styles.brandNameItem}>
            <img src={record.logo || `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/self-brand.png`} />
            <div style={{ lineHeight: '16px' }}>
              <Typography.Text
                ellipsis={{
                  tooltip: {
                    title: record.brandName,
                  }
                }}
                style={{ maxWidth: columnRenderDynamicConf.maxWidth - 20 }}
              ><>{record.brandName}</></Typography.Text>
            </div>
          </div>
        );
      }
    },
    {
      key: 'storeNumber',
      title: <div className={cs(['c-666 fs-12', styles.storeNumTitle])}>门店数</div>,
      importWidth: true,
      width: 'auto',
      noControlled: true,
      render(value) {
        return (
          <div className={styles.storeNumItem}>
            {value}
          </div>
        );
      }
    },
    {
      key: 'tendency',
      title: <div className={cs(['c-666 fs-12', styles.tendencyItemTitle])}>趋势</div>,
      width: 46,
      noControlled: true,
      render(_, record) {
        return (
          <div className={styles.tendencyItem}>
            {
              record.storeNumber === record.lastStoreNumber ? <div style={{ color: '#999' }}>--</div> : (
                <IconFont
                  iconHref={record.storeNumber - record.lastStoreNumber > 0 ? 'iconic_shangsheng' : 'iconiic_xiajiang'}
                  style={{
                    width: '12px',
                    height: '12px',
                    color: record.storeNumber - record.lastStoreNumber > 0 ? '#F23030' : '#02C681'
                  }}
                />
              )
            }
          </div>
        );
      }
    },
  ];

  const methods = useMethods({
    loadData() {
      return {
        dataSource: brandList || [],
        count: brandList.length || 0,
      };
    },
  });
  return (
    <>
      <TableOfBlue
      // key=''
        rowKey='brandName'
        onFetch={methods.loadData}
        filters={{}}
        defaultColumns={columns}
        hideColumnPlaceholder
        emptyRender
        voluntarilyEmpty
        pagination={false}
        floorWidth={46}
        scroll={isSAAS ? {
          y: 302
        } : {}}
      />
      <Divider style={{
        borderColor: '#fff', marginTop: '8px', marginBottom: '8px'
      }}/>
    </>
  );
};

export default memo(LeftConOfTopBrand);
